import "./Loader.css";

function Loader() {
  return (
    <div className="loader-container" role="status" aria-live="polite">
      <div className="loader-noise" aria-hidden="true" />
      <div className="loader-orb loader-orb-left" aria-hidden="true" />
      <div className="loader-orb loader-orb-right" aria-hidden="true" />

      <div className="loader-content">
        <div className="loader-logo-wrap">
          <div className="loader-logo-ring" aria-hidden="true" />
          <div className="loader-logo-core">
            <img src="/favicon.svg" alt="Logo augdev" className="loader-logo" />
          </div>
        </div>

        <span className="loader-badge">augdev portfolio</span>

        <h1 className="loader-title">
          Creation d&apos;experiences
          <span> digitales modernes</span>
        </h1>

        <p className="loader-text">
          Chargement de l&apos;interface du portfolio...
        </p>

        <div className="loader-progress" aria-hidden="true">
          <span />
        </div>
      </div>
    </div>
  );
}

export default Loader;
